import { CommonModule } from '@angular/common';
import { Component, OnInit, ViewChild } from '@angular/core';
import { FormsModule, NgForm, ReactiveFormsModule } from '@angular/forms';
import { AngularEditorComponent, AngularEditorConfig, AngularEditorModule } from '@kolkov/angular-editor';
import { FullSpinnerService } from '../../../services/full-spinner.service';
import { ActivatedRoute, Router } from '@angular/router';
import { HasPermissionDirective } from '../../../utils/has-permission.directive';
import { AppConstants } from '../../../utils/AppConstants';
import { ReportTemplateVar } from '../../../models/ReportTemplate';
import { DefaultReportTemplate } from '../../../models/DefaultReportTemplate';
import { ReportTemplateService } from '../../../services/report-template.service';
import { DefaultReportTemplateService } from '../../../services/default-report-template.service';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { AppEnums, EnumTypeTranslator } from '../../../models/AppEnums';
import { AlertService } from '../../shared/alert/alert.service';

@Component({
  selector: 'app-default-report-template-detail',
  standalone: true,
  imports: [
    CommonModule,
    AngularEditorModule,
    HasPermissionDirective,
    FormsModule,
    ReactiveFormsModule],
  templateUrl: './default-report-template-detail.component.html',
  styleUrl: './default-report-template-detail.component.scss',
})
export class DefaultReportTemplateDetailComponent implements OnInit {

  type?: string;
  defaultReportTemplate: DefaultReportTemplate = {};
  detail_title: string = 'Nuovo template default';
  @ViewChild('angularEditor') angularEditor?: AngularEditorComponent;
  @ViewChild('angularEditorHeader') angularEditorHeader?: AngularEditorComponent;
  innerHTML: string = "";
  headerHTML: string = "";

  previewHTML!: SafeHtml;
  editorConfig: AngularEditorConfig = {
    editable: true,
    spellcheck: false,
    height: 'auto',
    minHeight: 'calc(100vh - 520px)',
    maxHeight: 'auto',
    width: 'auto',
    minWidth: '0',
    translate: 'yes',
    enableToolbar: true,
    showToolbar: true,
    placeholder: 'Inserisci qui',
    defaultParagraphSeparator: '',
    defaultFontName: '',
    defaultFontSize: '',
    fonts: [
      { class: 'arial', name: 'Arial' },
      { class: 'times-new-roman', name: 'Times New Roman' },
      { class: 'calibri', name: 'Calibri' },
      { class: 'comic-sans-ms', name: 'Comic Sans MS' }
    ],

    uploadWithCredentials: false,
    sanitize: false,
    toolbarPosition: 'top',
    outline: false,
    toolbarHiddenButtons: [
      ['link', 'unlink', 'insertVideo']
    ],
    customClasses: [
      {
        name: 'Firme',
        class: '<!--',
        tag: 'table style="width:100%"><tr><td style="vertical-align: top">COL1</td><td style="vertical-align: top">COL2</td></tr></table> <!-- '
      },
      {
        name: 'Firme3',
        class: '<!--',
        tag: 'table style="width:100%;"><tr><td style="width:33.33%;vertical-align: top">COL1</td><td style="width:33.33%;vertical-align: top">COL2</td><td style="width:33.33%;vertical-align: top">COL3</td></tr></table> <!-- '
      }

    ]
  };

  editorHeaderConfig: AngularEditorConfig = {
    editable: true,
    spellcheck: true,
    height: 'auto',
    minHeight: '150px',
    maxHeight: 'auto',
    width: 'auto',
    minWidth: '0',
    translate: 'yes',
    enableToolbar: true,
    showToolbar: true,
    placeholder: 'Inserisci qui',
    defaultParagraphSeparator: '',
    defaultFontName: '',
    defaultFontSize: '',
    fonts: [
      { class: 'arial', name: 'Arial' },
      { class: 'times-new-roman', name: 'Times New Roman' },
      { class: 'calibri', name: 'Calibri' },
      { class: 'comic-sans-ms', name: 'Comic Sans MS' }
    ],

    uploadWithCredentials: false,
    sanitize: false,
    toolbarPosition: 'top',
    toolbarHiddenButtons: [
      ['link', 'unlink', 'insertVideo']
    ],
    rawPaste: true,
    customClasses: [

      {
        name: 'Intestazione',
        class: '<!--',
        tag: 'table><tr><td>COL1</td><td>COL2</td></tr></table> <!-- '
      }
    ]
  };

  showHideVariableClassHeader = "hide"
  showHideVariableClass = "hide"
  reportTemplateVariables: ReportTemplateVar[] = []
  reportTemplateVariablesFiltered: ReportTemplateVar[] = []

  reportTemplateTypes: EnumTypeTranslator[] = AppEnums.reportTemplateTypes

  constructor(
    private sanitizer: DomSanitizer,
    private reportTemplateService: ReportTemplateService,
    private defaultReportTemplateService: DefaultReportTemplateService,
    private alertService: AlertService,
    private fullSpinnerService: FullSpinnerService,
    private router: Router,
    private activatedRoute: ActivatedRoute) {
    fullSpinnerService.spinner(undefined);

  }
  ngOnInit(): void {

    this.reportTemplateService.findAllVars().subscribe({
      next: (res) => {
        this.reportTemplateVariables = res
        this.reportTemplateVariablesFiltered = res
      }, complete: () => {
      }
      , error: () => {
      }
    });

    this.type = this.activatedRoute.snapshot.paramMap.get('type') ?? undefined;
    if (this.type) {
      this.fullSpinnerService.spinner('');
      this.defaultReportTemplateService.get(this.type).subscribe({
        next: (res) => {
          this.defaultReportTemplate = res;
          this.detail_title = res.name!;
          this.innerHTML = res.innerHtml!;
          this.headerHTML = res.headerHtml!
          this.previewHTML = this.sanitizer.bypassSecurityTrustHtml(res.headerHtml! + res.innerHtml!)

        }, complete: () => {
          this.fullSpinnerService.spinner(undefined);
        }
        , error: () => {
          this.fullSpinnerService.spinner(undefined);
        }
      });
    }
    else {
      // In creazione propongo solo le tipologie che non hanno ancora un template default
      this.defaultReportTemplateService.find({ pageSize: 0, pageNumber: 1 }).subscribe({
        next: (res) => {
          const usedTypes = res.items.map(item => item.type);
          this.reportTemplateTypes = AppEnums.reportTemplateTypes.filter(type => !usedTypes.includes(type.id));
        }
      });
    }
  }

  onSubmit(form: NgForm): void {
    if (form.valid) {
      this.fullSpinnerService.spinner('');
      this.defaultReportTemplate.innerHtml = this.angularEditor?.textArea.nativeElement.innerHTML
      this.defaultReportTemplate.headerHtml = this.angularEditorHeader?.textArea.nativeElement.innerHTML
      const save$ = this.type
        ? this.defaultReportTemplateService.update(this.type, this.defaultReportTemplate)
        : this.defaultReportTemplateService.create(this.defaultReportTemplate);
      save$.subscribe({
        next: (res) => {
          this.alertService.addErrors(AppConstants.titleSuccessMessage, [AppConstants.successMessage], true);
          this.router.navigate(['default-report-templates']);
        }, complete: () => {
          this.fullSpinnerService.spinner(undefined);
        }
        , error: () => {
          this.alertService.addErrors(AppConstants.titleErrorMessage, [AppConstants.errorMessage], true);
          this.fullSpinnerService.spinner(undefined);
        }
      });
    }
  }

  back() {
    this.router.navigate(['default-report-templates']);
  }

  showHideVarialePanel(header: boolean) {
    if (header)
      this.showHideVariableClassHeader = this.showHideVariableClassHeader == "hide" ? "show" : "hide"
    else
      this.showHideVariableClass = this.showHideVariableClass == "hide" ? "show" : "hide"

  }

  filterVars(event: any) {
    let value = event.target.value;
    this.reportTemplateVariablesFiltered = this.reportTemplateVariables.filter(n => n.name!.toLowerCase().indexOf(value.toLowerCase()) > -1)

  }
}
